import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import { SagaIterator } from "@redux-saga/core";

// helpers
import {
  addSubCourse as addSubCourseApi,
  updateSubCourse as updateSubCourseApi,
  getSubCourse as getSubCourseApi,
  deleteSubCourse as deleteSubCourseApi,
} from "../../helpers/";

// actions
import {
  subCourseApiResponseSuccess,
  subCourseApiResponseError,
  getSubCourse,
} from "./actions";

// constants
import { SubCourseActionTypes } from "./constants";

interface subCourseData {
  payload: {
    id: number;
    name: string;
    courseId: string;
  };
  type: string;
}

function* createSubCourse({
  payload: { name, courseId },
  type,
}: subCourseData): SagaIterator {
  try {
    const response = yield call(addSubCourseApi, {
      name,
      courseId,
    });

    const subCourseData = response.data.message;
    // NOTE - You can change this according to response format from your api

    yield put(
      subCourseApiResponseSuccess(
        SubCourseActionTypes.CREATE_SUB_COURSE,
        subCourseData
      )
    );
    yield put(getSubCourse());
  } catch (error: any) {
    yield put(
      subCourseApiResponseError(SubCourseActionTypes.CREATE_SUB_COURSE, error)
    );
  }
}

function* updateSubCourse({
  payload: { id, name, courseId },
}: subCourseData): SagaIterator {
  try {
    const response = yield call(updateSubCourseApi, id, {
      name,
      courseId,
    });
    const subCourseData = response.data.message;
    // NOTE - You can change this according to response format from your api

    yield put(
      subCourseApiResponseSuccess(
        SubCourseActionTypes.UPDATE_SUB_COURSE,
        subCourseData
      )
    );
    yield put(getSubCourse());
  } catch (error: any) {
    yield put(
      subCourseApiResponseError(SubCourseActionTypes.UPDATE_SUB_COURSE, error)
    );
  }
}

function* getSubCourses(): SagaIterator {
  try {
    const response = yield call(getSubCourseApi);

    const subCourseData = response?.data?.subcourses;

    yield put(
      subCourseApiResponseSuccess(
        SubCourseActionTypes.GET_SUB_COURSE,
        subCourseData
      )
    );
  } catch (error: any) {
    yield put(
      subCourseApiResponseError(SubCourseActionTypes.GET_SUB_COURSE, error)
    );
  }
}

function* deleteSubCourse({ payload: { id } }: subCourseData): SagaIterator {
  try {
    const response = yield call(deleteSubCourseApi, id);
    const subCourseData = response.data.message;
    // NOTE - You can change this according to response format from your api

    yield put(
      subCourseApiResponseSuccess(
        SubCourseActionTypes.DELETE_SUB_COURSE,
        subCourseData
      )
    );
    yield put(getSubCourse());
  } catch (error: any) {
    yield put(
      subCourseApiResponseError(SubCourseActionTypes.DELETE_SUB_COURSE, error)
    );
  }
}

export function* watchCreateSubCourse() {
  yield takeEvery(SubCourseActionTypes.CREATE_SUB_COURSE, createSubCourse);
}
export function* watchUpdateSubCourse() {
  yield takeEvery(SubCourseActionTypes.UPDATE_SUB_COURSE, updateSubCourse);
}
export function* watchGetSubCourse() {
  yield takeEvery(SubCourseActionTypes.GET_SUB_COURSE, getSubCourses);
}

export function* watchDeleteSubCourse() {
  yield takeEvery(SubCourseActionTypes.DELETE_SUB_COURSE, deleteSubCourse);
}

function* subCourseSaga() {
  yield all([
    fork(watchCreateSubCourse),
    fork(watchUpdateSubCourse),
    fork(watchDeleteSubCourse),
    fork(watchGetSubCourse),
  ]);
}

export default subCourseSaga;
